import { ButtonProps, ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { style } from 'typestyle';
import { Messages } from '../../codegen/Localize';

const buttonWrapper = style({
  display: 'flex',
});

const rightAlignButtonStyle = style({
  marginLeft: 'auto',
});

export interface LinkedTasksDialogFooterProps {
  addNextTask: () => void;
  cancel: () => void;
  createTask: () => void;
}

export function LinkedTasksDialogFooter(props: LinkedTasksDialogFooterProps) {
  const addNextTaskButtonProps: ButtonProps = {
    testId: 'linked-tasks-dialog-add-new-task',
    handleClick: props.addNextTask,
  };
  const cancelButtonProps: ButtonProps = {
    testId: 'linked-tasks-dialog-cancel',
    handleClick: props.cancel,
  };
  const createTasksButtonProps: ButtonProps = {
    buttonType: ButtonType.Primary,
    testId: 'linked-tasks-dialog-create-tasks',
    style: { marginLeft: `${TabStyles.Spacing.MediumSpace}px` },
    handleClick: props.createTask,
  };
  return (
    <div className={buttonWrapper}>
      <ButtonWidget {...addNextTaskButtonProps}>{Messages.linkedTasksAddNextTask()}</ButtonWidget>
      <div className={rightAlignButtonStyle}>
        <ButtonWidget {...cancelButtonProps}>{Messages.cancel()}</ButtonWidget>
        <ButtonWidget {...createTasksButtonProps}>{Messages.linkedTasksCreateTasks()}</ButtonWidget>
      </div>
    </div>
  );
}
